import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { themeGet } from 'styled-system';

import VisuallyHidden from '@shared/v2/components/VisuallyHidden';

import Flight from '@/propTypes/Flight';
import FlightDetail from './components/FlightDetail';
import TransitDetail from './components/TransitDetail';
import enrichWithStopOver from './helpers/enrichWithStopOver';

const Container = styled(Box)`
  border-top: 1px solid ${themeGet('dividers.horizontal.backgroundColor')};
`;

const FlightsDetails = ({ flights, show, ...props }) => {
  if (!show) {
    return null;
  }

  return (
    <Container
      pt={4}
      {...props} // eslint-disable-line react/jsx-props-no-spreading
    >
      <section>
        <VisuallyHidden>
          {/* Note: Heading level may need to change if using in other pages */}
          <h5>Flight details</h5>
        </VisuallyHidden>
        {enrichWithStopOver(flights).map((flight) => {
          if (!flight.stopOver || isEmpty(flight.stopOver)) {
            return <FlightDetail flight={flight} key={flight.flightNumber} />;
          }

          return (
            <Box
              key={`${flight.flightNumber}-${flight.origin?.code}-${flight.destination?.code}`}
            >
              <TransitDetail
                stopOver={flight.stopOver}
                location={flight.origin.name}
              />
              <FlightDetail flight={flight} />
            </Box>
          );
        })}
      </section>
    </Container>
  );
};

FlightsDetails.propTypes = {
  flights: PropTypes.arrayOf(PropTypes.shape(Flight)),
  show: PropTypes.bool.isRequired,
};

export default FlightsDetails;
